

























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'UserTotal',
})
export default class UserTotal extends Vue {
    @Prop(Number) private totalMen: number;
    @Prop(Number) private usersTotal: number;
    @Prop(Number) private totalWomen: number;
    @Prop(Boolean) private isLoading: boolean;
}
